<template>
  <SfDataPlaceholder>
    {{ $t('SHOP.ORDER.MESSAGE.CHOOSE_SHIPPING_METHOD_FIRST') }}
  </SfDataPlaceholder>
</template>
